export const PaginationFilterType = {
    BOOLEAN: 'BOOLEAN',
    TEXT: 'TEXT',
    NUMBER: 'NUMBER',
    DATE: 'DATE',
    SELECT: 'SELECT',
    MULTI_SELECT: 'MULTI_SELECT',
    DATE_RANGE: 'DATE_RANGE',
};
